import { withJsonFormsControlProps } from "@jsonforms/react";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";

import { ChangeEvent, useEffect, useState } from "react";
import { ISelectProvider, IOptions } from "./types";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectProps } from "@mui/material/Select";
import { ApiFinancialRequest } from "data/ApiFinancial";

const SelectProvider = (props: ISelectProvider) => {
  const { data, handleChange, path, errors, required } = props;
  const [options, setOptions] = useState<IOptions[]>([]);

  const handleOnChange: SelectProps["onChange"] = (event) => {
    const newValue = event.target.value;
    handleChange(path, newValue);
  };

  useEffect(() => {
    ApiFinancialRequest<GetAllGql>({
      query: GET_ALL_QUERY,
    })
      .then((response) => {
        if (!response?.data?.data?.PaymentAffiliantion) {
          throw new Error("Não encontrado", {
            cause: { response: response?.data || response },
          });
        }

        const data = response.data.data?.PaymentAffiliantion;

        const newOptions: IOptions[] = data.map(({ id, name }) => ({
          label: name,
          value: id,
        }));

        setOptions(newOptions);
      })
      .catch((error) => {
        console.log({ error });
      });
  }, []);

  return (
    <FormControl
      variant="standard"
      fullWidth
      required={required}
      error={!!errors}
      sx={{ marginBottom: "10px" }}
    >
      <InputLabel>{props.label}</InputLabel>
      <Select value={data} label={props.label} onChange={handleOnChange}>
        <MenuItem value="">Selecione...</MenuItem>
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={`${value}`}>
            {label}
          </MenuItem>
        ))}
      </Select>
      {errors && <FormHelperText>{errors}</FormHelperText>}
    </FormControl>
  );
};

export default withJsonFormsControlProps(SelectProvider, true);
